import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { QuickAddButton } from "@/components/QuickAddButton";

export function AppLayout() {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <div className="flex-1 flex flex-col">
          <header className="h-14 flex items-center gap-4 border-b border-border px-4 bg-card">
            <SidebarTrigger />
            <h2 className="text-sm font-medium text-muted-foreground">
              SEO Analysis Dashboard
            </h2>
          </header>
          <main className="flex-1 p-6 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
      <QuickAddButton />
    </SidebarProvider>
  );
}
